export default __webpack_public_path__ + "static/media/premium_female.99ba7423.png";